import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PersonalizeService } from '../personalize.service';
import { PersonalizeActions } from './personalize.actions';

@Injectable({
    providedIn: 'root'
})
export class PersonalizeEpics implements RidangoEpic {
    constructor(
        private actions: PersonalizeActions,
        private service: PersonalizeService
    ) {}

    register() {
        return [this.savePersonalizedCard, this.savePersonalizedCardNoIssue];
    }

    savePersonalizedCard = (action$: ActionsObservable<any>) =>
        action$.ofType(PersonalizeActions.SAVE_PERSONALIZED_CARD).pipe(
            switchMap(({ payload: { isStrongAuth, ...payload } }: RidangoReduxAction) =>
                (isStrongAuth ? this.service.postPersoAuth(payload) : this.service.postPerso(payload)).pipe(
                    map((d: any) => this.actions.savePersonalizedCardSuccess(d)),
                    catchError((error) => {
                        if (error.name && error.status === 0) {
                            const browserError = { error: error.name };
                            return of(this.actions.savePersonalizedCardFailed(browserError));
                        }
                        return of(this.actions.savePersonalizedCardFailed(error));
                    })
                )
            )
        );

    savePersonalizedCardNoIssue = (action$: ActionsObservable<any>) =>
        action$.ofType(PersonalizeActions.SAVE_PERSONALIZED_CARD_NO_ISSUE).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.postPersoNoIssue(action.payload).pipe(
                    map((d: any) => this.actions.savePersonalizedCardNoIssueSuccess(d)),
                    catchError((error) => {
                        if (error.name && error.status === 0) {
                            const browserError = { error: error.name };
                            return of(this.actions.savePersonalizedCardNoIssueFailed(browserError));
                        }
                        return of(this.actions.savePersonalizedCardNoIssueFailed(error));
                    })
                );
            })
        );
}
